import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "metaweb-tab-container p-d-flex p-flex-column kn-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_BusinessModelTab = _resolveComponent("BusinessModelTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_MetawebPhysicalModel = _resolveComponent("MetawebPhysicalModel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_MetawebInvalidRelationshipsDialog = _resolveComponent("MetawebInvalidRelationshipsDialog")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "metaweb-dialog remove-padding p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.mainDescriptor.style.flex,
    visible: _ctx.visible,
    modal: false,
    closable: false,
    position: "right",
    baseZIndex: 1,
    autoZIndex: true
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('metaweb.title')), 1)
        ]),
        end: _withCtx(() => [
          _withDirectives(_createVNode(_component_Button, {
            icon: "pi pi-save",
            class: "p-button-text p-button-rounded p-button-plain",
            onClick: _ctx.metadataSave
          }, null, 8, ["onClick"]), [
            [
              _directive_tooltip,
              _ctx.$t('common.save'),
              void 0,
              { bottom: true }
            ]
          ]),
          _withDirectives(_createVNode(_component_Button, {
            icon: "pi pi-times",
            class: "p-button-text p-button-rounded p-button-plain",
            onClick: _ctx.closeMetawebConfirm
          }, null, 8, ["onClick"]), [
            [
              _directive_tooltip,
              _ctx.$t('common.close'),
              void 0,
              { bottom: true }
            ]
          ])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              class: "kn-progress-bar",
              mode: "indeterminate",
              "data-test": "progress-bar"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_TabView, { class: "metaweb-tabview p-d-flex p-flex-column kn-flex" }, {
          default: _withCtx(() => [
            _createVNode(_component_TabPanel, null, {
              header: _withCtx(() => [
                _createVNode("span", null, _toDisplayString(_ctx.$t('metaweb.businessModel.title')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_BusinessModelTab, {
                  businessModelId: _ctx.businessModel.dataSourceId,
                  propMeta: _ctx.meta,
                  observer: _ctx.observer,
                  metaUpdated: _ctx.metaUpdated,
                  onMetaUpdated: _ctx.onMetaUpdated
                }, null, 8, ["businessModelId", "propMeta", "observer", "metaUpdated", "onMetaUpdated"])
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, null, {
              header: _withCtx(() => [
                _createVNode("span", null, _toDisplayString(_ctx.$t('metaweb.physicalModel.title')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_MetawebPhysicalModel, {
                  propMeta: _ctx.meta,
                  observer: _ctx.observer,
                  onLoading: _ctx.setLoading
                }, null, 8, ["propMeta", "observer", "onLoading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_MetawebInvalidRelationshipsDialog, {
        visible: _ctx.invalidRelationshipsDialogVisible,
        propIncorrectRelationships: _ctx.incorrectRelationships,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.invalidRelationshipsDialogVisible = false)),
        onSave: _ctx.generateModel
      }, null, 8, ["visible", "propIncorrectRelationships", "onSave"])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
}